import React, { useState } from "react";

function Contact() {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 5000);
  };

  return (
    <div>
      {/* Hero Header - Italian Theme with Background Image */}
      <div
        className="container-fluid py-5 mb-5 hero-header position-relative"
        style={{
          background:
            'linear-gradient(135deg, rgba(11, 19, 32, 0.85) 0%, rgba(28, 62, 85, 0.85) 100%), url("https://images.unsplash.com/photo-1499092346589-b9b6be3e94b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1171&q=80")',
          backgroundSize: "cover",
          backgroundPosition: "center 40%",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Contact Us
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/" style={{ color: "#D4AF37" }}>
                      Home
                    </a>
                  </li>
                  <li
                    className="breadcrumb-item text-white active"
                    aria-current="page"
                    style={{ color: "#FFFFFF" }}
                  >
                    Contact
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Start */}
      <div className="container-xxl py-5" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center px-3" style={{ color: '#D4AF37', fontWeight: '700' }}>
              Contact Us
            </h6>
            <h1 className="mb-5" style={{ color: '#0B1320' }}>Get In Touch With Us</h1>
          </div>

          {/* Success Message */}
          {showSuccess && (
            <div 
              className="alert alert-success rounded-pill mb-4 text-center animate__animated animate__fadeIn"
              style={{ 
                backgroundColor: '#D4AF37', 
                color: '#0B1320',
                border: 'none',
                fontWeight: 'bold'
              }}
            >
              <i className="fa fa-check-circle me-2"></i>
              Your message has been sent! Our team will contact you within 24 hours. Grazie!
            </div>
          )}

          <div className="row g-4">
            {/* Contact Information - Rome Office */}
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
              <h5 style={{ color: '#0B1320' }}>Get In Touch</h5>
              <p className="mb-4" style={{ color: '#555555' }}>
                Visit our office near the Colosseum or reach out to us via phone or email. We're here to help you plan your perfect Italian adventure!
              </p>
              <div className="d-flex align-items-center mb-4">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0 rounded"
                  style={{ width: 50, height: 50, backgroundColor: '#D4AF37' }}
                >
                  <i className="fa fa-map-marker-alt" style={{ color: '#0B1320' }} />
                </div>
                <div className="ms-3">
                  <h5 style={{ color: '#D4AF37' }}>Our Office</h5>
                  <p className="mb-0" style={{ color: '#555555' }}>
                    Via dei Fori Imperiali, 10<br />
                    00184 Roma RM, Italy<br />
                    (Near Colosseum)
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center mb-4">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0 rounded"
                  style={{ width: 50, height: 50, backgroundColor: '#D4AF37' }}
                >
                  <i className="fa fa-phone-alt" style={{ color: '#0B1320' }} />
                </div>
                <div className="ms-3">
                  <h5 style={{ color: '#D4AF37' }}>Phone</h5>
                  <p className="mb-0" style={{ color: '#555555' }}>+39 06 1234 5678</p>
                  <p className="mb-0" style={{ color: '#555555' }}>+39 345 678 9012 (WhatsApp)</p>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0 rounded"
                  style={{ width: 50, height: 50, backgroundColor: '#D4AF37' }}
                >
                  <i className="fa fa-envelope-open" style={{ color: '#0B1320' }} />
                </div>
                <div className="ms-3">
                  <h5 style={{ color: '#D4AF37' }}>Email</h5>
                  <p className="mb-0" style={{ color: '#555555' }}>info@viaitaliatours.com</p>
                  <p className="mb-0" style={{ color: '#555555' }}>bookings@viaitaliatours.com</p>
                </div>
              </div>
            </div>

            {/* Google Map - Colosseum Area */}
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
              <div className="position-relative rounded overflow-hidden shadow" style={{ minHeight: 350, height: '100%' }}>
                <iframe
                  className="position-relative rounded w-100 h-100"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2969.654246110987!2d12.48823031544413!3d41.89021097922088!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132f61b653e7f2b5%3A0x5e2e3f4b8b9b9f0e!2sColosseum!5e0!3m2!1sen!2sit!4v1645449442684!5m2!1sen!2sit"
                  frameBorder={0}
                  style={{ border: 0 }}
                  allowFullScreen
                  aria-hidden="false"
                  tabIndex={0}
                  title="Via Italia Tours Office Location near Colosseum"
                />
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-4 col-md-12 wow fadeInUp" data-wow-delay="0.5s">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="Your Name"
                        style={{ borderColor: '#D4AF37' }}
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="name" style={{ color: '#D4AF37' }}>Your Name</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Your Email"
                        style={{ borderColor: '#D4AF37' }}
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="email" style={{ color: '#D4AF37' }}>Your Email</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="subject"
                        placeholder="Subject"
                        style={{ borderColor: '#D4AF37' }}
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="subject" style={{ color: '#D4AF37' }}>Subject</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        placeholder="Leave a message here"
                        id="message"
                        style={{ height: 100, borderColor: '#D4AF37' }}
                        value={formData.message}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="message" style={{ color: '#D4AF37' }}>Message</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <button
                      className="btn w-100 py-3 rounded-pill"
                      type="submit"
                      style={{
                        backgroundColor: '#D4AF37',
                        color: '#0B1320',
                        fontWeight: 'bold',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#87CEEB';
                        e.currentTarget.style.color = '#0B1320';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#D4AF37';
                        e.currentTarget.style.color = '#0B1320';
                      }}
                    >
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Contact End */}
    </div>
  );
}

export default Contact;